var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpdateOnboardingStage({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.33331 3.75008C3.33331 2.59949 4.26605 1.66675 5.41665 1.66675H10.1935C10.746 1.66675 11.2759 1.88624 11.6666 2.27694L15.2231 5.83341C15.6138 6.22412 15.8333 6.75402 15.8333 7.30655V16.2501C15.8333 17.4007 14.9006 18.3334 13.75 18.3334H5.41665C4.26605 18.3334 3.33331 17.4007 3.33331 16.2501V3.75008ZM5.41665 10.0001C5.41665 9.42478 5.88302 8.95841 6.45831 8.95841H12.7083C13.2836 8.95841 13.75 9.42478 13.75 10.0001C13.75 10.5754 13.2836 11.0417 12.7083 11.0417H6.45831C5.88302 11.0417 5.41665 10.5754 5.41665 10.0001ZM6.45831 13.1251C5.88302 13.1251 5.41665 13.5915 5.41665 14.1667C5.41665 14.742 5.88302 15.2084 6.45831 15.2084H12.7083C13.2836 15.2084 13.75 14.742 13.75 14.1667C13.75 13.5915 13.2836 13.1251 12.7083 13.1251H6.45831Z",
    fill: "#23242A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdateOnboardingStage);
export default __webpack_public_path__ + "static/media/update-onboarding-stage.810b64d36b65d254b3a9802f51d3cfbc.svg";
export { ForwardRef as ReactComponent };